import clsx from 'clsx';
import React from 'react';

import FAQSection from '2_sections/FAQSection/FAQSection';

import { faqSectionData } from './SideMenu.data';

import S from './SideMenu.module.scss';

export interface SideMenuProps {
  className?: string;
}

export const SideMenu: React.FC<SideMenuProps> = ({ className, ...rest }) => {
  return (
    <div
      id="side_menu_wrapper"
      className={clsx(S.MenuWrapper, className)}
      {...rest}
    >
      <FAQSection data={faqSectionData} />
    </div>
  );
};
